import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map, mapTo, switchMap } from 'rxjs/operators';
import { LoginService } from '../services/login.service';
import { UserConfigService } from 'src/modules/shared/services/userConfig.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { CommonService } from 'src/modules/shared/services/common.service';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { ApplicantManagementService } from 'src/modules/profile-management/services/applicant-management-service.service';
import { PopupNotificationComponent } from 'src/modules/shared/request/popup-notification/popup-notification.component';
import { BsModalService } from 'ngx-bootstrap';
import { Mode } from 'src/modules/shared/form-guide/utility/enums/enums';
import { EmailLoginService } from '../services/Email-login.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { NgForm } from '@angular/forms';
import { of } from 'rxjs';
import {CompanySaveRequest, ICompanySaveRequest} from "../../shared/interfaces/ICompanySaveRequest";

@Component({
  selector: 'app-email-login-integration',
  templateUrl: './email-login-integration.component.html',
  styleUrls: ['./email-login-integration.component.scss']
})
export class EmailLoginIntegrationComponent implements OnInit {
  selectedType: number;
  chosenModule: { user?: {}, module?: { Label?: string, Value?: number } } = {};
  currentUser: { Email?: string, lang?: string; type?: string; cr?: string; cpr?: string; isChangeLogin?: boolean; };
  ticket: any;
  sessionId: any;
  Email: any;
  authenticationInfo: any;
  alertModalRef: any;
  companyInfo: { Name: string, Id: string } = { Name: "", Id: "" };
  userData: { UserType?: number, UserCPR?: string, UserCR?: string, Module?: number, UserId?: string, ApplicantId?: string } = {};
  Module: any;
  token: string;
  invalid: boolean=false;
  CRNumberIsExist: boolean=false;
  hideCompany:boolean=false;
  ProfileType: any="";
  isProduction: boolean;

  constructor(
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private route: Router,
    private loginService: EmailLoginService,
    private userConfigService: UserConfigService,
    private dbService: NgxIndexedDBService,
    private appConfig: AppConfigService,
    private applicantService: ApplicantManagementService,
    private translate: TranslateService) {
    this.Module = "Aeronautical Licensing Directorate";
    this.chosenModule = { user: {}, module: { Value: 4 } };
    this.isProduction = JSON.parse(this.appConfig.getAppConfig().IsProduction);
    this.GetParamters();
    // if (this.isProduction) {
    //   this.GetAuthenticationDetails();
    // } else {
    //   //this.authenticationInfo.CPR = this.commonService.GetParametersByName('cpr');

    // }

    this.currentUser = {
      lang: this.translate.currentLang,
      type: this.userConfigService.getUserType(),
      isChangeLogin: false
    }
  }

  UserId: string = "";
  hasCompany: boolean = true;
  NewCompany: ICompanySaveRequest = CompanySaveRequest;

  Individual = { email: "", cpr: "" };
  ngOnInit() {
    debugger;
    this.selectedType = 1;
    this.currentUser.isChangeLogin = history.state.isChangeLogin !== null && history.state.isChangeLogin !== undefined ? history.state.isChangeLogin : false;
    if (this.currentUser.isChangeLogin) {
      this.retrieveEmailFromIndexedDB();
    }
    else {

    }
    //check paramters
    if (this.sessionId != null && this.token != null && this.ticket != null) {
      this.loginService.DecodeToken(this.token).pipe(switchMap((response) => {
        debugger;
        //if token valid 
        if (response != null) {
          this.Individual.email = response.Data.Email;
          this.Email = response.Data.Email;
          this.UserId = response.Data.Id;
          this.userData.ApplicantId = response.Data.Id;
          this.ProfileType=response.Data.ProfileType;
          if(this.ProfileType=="individual"){
            this.hideCompany=true;
            return of(null)
          }
          else{
            return this.loginService.GetRelatedCompany(this.userData);
          }
        }
        else {
          this.route.navigate(['/error']);
          return of(null)
        }
      }
      )).subscribe((data) => {
        debugger;
        if(data){
          this.hasCompany = data.body == null ? false : true;
          if (this.hasCompany) {
            data = data["body"]["Result"];
            this.companyInfo = { Name: data.Name, Id: data.Id };
          }

        }
      })
    }
    else {
      this.route.navigate(['/error']);
    }



    // this.activatedRoute.data.subscribe((data) => {
    //   // if(data)
    // });

  }



  //#endregion
  //in case new regstration

  //create new accont >>get account info >> set in db session 


  //#region New Registration
  /**
   * 1-create new company
   * 2-associate contact with that company
   * 3-update contact from individual to be company (profile type) and key person
   * 4-save in session
   * 5-save in user config
   * 
   */

  NewRegistration(formModel: NgForm) {
    debugger;
    LoaderService.showLoader();
    if (formModel.valid) {
      LoaderService.showLoader();

      this.loginService.CheckCRnumber(formModel.control.value.CrNumber).pipe(switchMap(response => {
        if (!response.Result) {
          this.NewCompany.IndividualId = this.UserId;
          this.NewCompany.CrNumber = formModel.control.value.CrNumber;
          this.CRNumberIsExist=false;
          this.invalid = false;
          return this.loginService.CreateCompany(this.NewCompany);
        }
        else {
          this.CRNumberIsExist=true;
          this.invalid = true
          return of(null)
        }
      }))
        //login as new company
        .subscribe((response: any) => {
          debugger;
          if(response!=null){
            response = response.Result;
            if (response != null) {
              //save in seesion 
              this.addToUserLoginDB(4, response.AccountID);
              this.userConfigService.setUserConfig(
                  response.UserType,
                  response.UserName,
                  response.EnglishUserName,
                  response.ArabicUserName,
                  response.AccessToken,
                  4,
                  response.IdleTimeoutValue,
                  response.TokenExpiryTime,
                  response.InactivityTimeValueForAutomaticLogout);
              // this.userConfigService.setLoggenInUserRole(this.applicantResponse.IsOwner, this.applicantResponse.IsPrimaryContact, this.applicantResponse.IsBoth);
              // window.location.href='/home';
              this.route.navigate(['/home']);
              //ald moudle
              localStorage.setItem('Module', "4");
            }
          }
          else {
            this.route.navigate(['/home']);
            LoaderService.hideLoader();
          }
          LoaderService.hideLoader();
        })
     //   LoaderService.hideLoader();
      }
    else{
      this.invalid=true;
      LoaderService.hideLoader();
    }

  }
  //#endregion

  GetParamters() {

    this.ticket = this.commonService.GetParametersByName('ticket');
    this.sessionId = this.commonService.GetParametersByName('classSessionId');
    this.token = this.commonService.GetParametersByName('token');
  }

  //#region 

  //Already exist Company Login
  companyLogin() {
    
    LoaderService.showLoader();
    this.userData = { Module: 4, UserType: 1, UserId: this.companyInfo.Id, ApplicantId: this.userData.ApplicantId };
    this.loginService.GetApplicantInfoById(this.userData).subscribe((response) => {
    
      if (response != null) {
        response = response.Result;

        this.addToUserLoginDB(4, response.AccountID);
        this.userConfigService.setUserConfig(response.UserType, response.EnglishUserName, response.EnglishUserName, response.ArabicUserName, response.AccessToken, 4, response.IdleTimeoutValue, response.TokenExpiryTime, response.InactivityTimeValueForAutomaticLogout);
        localStorage.setItem('Module', this.userData.Module.toString());
        this.route.navigate(['/home']);
      }
      LoaderService.hideLoader();
    })
  }
  //#endregion

  //Individaul User
  IndividualLogin() {
    LoaderService.showLoader();
    this.userData = { Module: 4, UserType: 2, ApplicantId: this.userData.ApplicantId };
    this.loginService.GetApplicantInfoById(this.userData).subscribe((response) => {
      debugger;
      if (response != null) {
        response = response.Result;

        this.addToUserLoginDB(4, response.AccountID);
        this.userConfigService.setUserConfig(response.UserType, response.UserName, response.EnglishUserName, response.ArabicUserName, response.AccessToken, 4, response.IdleTimeoutValue, response.TokenExpiryTime, response.InactivityTimeValueForAutomaticLogout);
        localStorage.setItem('Module', this.userData.Module.toString());
        this.route.navigate(['/home']);
      }
      LoaderService.hideLoader();

    })
  }
  // resetModulesValues(){
  //   let initModules = JSON.parse(JSON.stringify(this.Modules));

  //   initModules.forEach(module => {
  //     let index = -1;
  //     index = this.Modules.indexOf(this.Modules.filter(m => m.Label === module.Label)[0]);
  //     if (index !== -1) {
  //       this.Modules[index].Value = this.currentUser.lang === 'en' ?
  //       UserConfigService.MTTModulesEn.filter(crm => crm.Label === this.Modules[index].Label)[0].Value
  //       : UserConfigService.MTTModulesAr.filter(crm => crm.Label === this.Modules[index].Label)[0].Value;
  //     }});
  // }
  changeType(type) {
    this.selectedType = type;
    // this.applicantCrs = [];
    // this.isLoginButtonDisabled = true;
    // this.isModuleDropDownVisible = false;
    // this.Modules = [];


  }

  addToUserLoginDB(chosenModule: number = 1, CompanyId: string = "123") {

    this.dbService.getAll('userLoginsDB').then(
      userLoginsDB => {
        debugger;
        console.log(userLoginsDB);
        //new login
        if (userLoginsDB && userLoginsDB.length === 0) {
          this.dbService.add('userLoginsDB', { Type: this.selectedType, Email: this.Individual.email,
            CompanyId: CompanyId, ChosenModule: chosenModule }).then(
            () => { },
            error => {
              console.log(error);
            }
          );
        }
        //update login
        else if (userLoginsDB && userLoginsDB.length === 1) {
          this.dbService.update('userLoginsDB', { id: userLoginsDB[0]['id'], Type: this.selectedType,
            Email: this.Individual.email, CompanyId: CompanyId, ChosenModule: chosenModule }).then(
            () => { },
            error => {
              console.log(error);
            }
          );
        } else {
          this.dbService.clear('userLoginsDB').then(
            () => {
              this.dbService.add('userLoginsDB', { Type: this.selectedType, Email: this.Individual.email,
                CompanyId: CompanyId, ChosenModule: chosenModule }).then(
                () => { },
                error => {
                  console.log(error);
                }
              );
            },
            error => {
              console.log(error);
            }
          );
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  GetAuthenticationDetails() {
    this.ticket = this.commonService.GetParametersByName('ticket');
    this.sessionId = this.commonService.GetParametersByName('clasSessionId');

    if (this.ticket && this.sessionId && (this.ticket !== '' || this.sessionId !== '')) {
      LoaderService.showLoader();
      this.applicantService.RequestingAuthenticationResult(
        { Ticket: this.ticket, SessionId: this.sessionId }).subscribe(
          response => {
            LoaderService.hideLoader();
            this.authenticationInfo = response["Result"];
            if (response["Status"] === "Success") {
              if (response["Result"]) {
                if (this.authenticationInfo && this.authenticationInfo.Status
                  && this.authenticationInfo.Status.toString() === "Success") {
                  //this.CPRNumber = JSON.parse(JSON.stringify(this.authenticationInfo.CPR));
                  // this.getUserCrs();
                }
              } else {
                this.route.navigate(['/error']);
              }
            } else {
              if (this.authenticationInfo && this.authenticationInfo.Status
                && this.authenticationInfo.Status.toString() !== "Success") {
                let backLabelText, failHeader, failBody = "";
                this.translate.get("Login-container.Message.TryAgain")
                  .subscribe(value => backLabelText = value);
                this.translate.get("Login-container.Message.AuthenticationFailed")
                  .subscribe(value => failHeader = value);
                this.translate.get("Login-container.Message.AuthenticationNotSuccessful")
                  .subscribe(value => failBody = value);
                const initialState = {
                  alertMode: Mode.Error,
                  alertHeader: failHeader,
                  alertMassage: failBody,
                  navigateOnExit: true,
                  exitNavigationURL: 'home',
                  enableNavigation: true,
                  backLableText: backLabelText,
                  navigationURL: 'login/redirect'
                };
                this.alertModalRef = this.modalService.show(
                  PopupNotificationComponent,
                  {
                    initialState,
                    backdrop: true,
                    ignoreBackdropClick: true,
                    keyboard: false,
                  },
                );
              } else {
                this.route.navigate(['/error']);
              }
            }
          }, (err) => {
            LoaderService.hideLoader();
            this.route.navigate(['/error']);
          });
    }
  }
  retrieveEmailFromIndexedDB() {
    this.dbService.getAll('userLoginsDB').then(
      loggedInUsers => {
        if (loggedInUsers && loggedInUsers.length > 0 && loggedInUsers[0]['CR'] && loggedInUsers[0]['Email'] && loggedInUsers[0]['Type']) {
          this.currentUser.cpr = loggedInUsers[0]['Email'];
          this.currentUser.cr = loggedInUsers[0]['CR'];
          this.Email = loggedInUsers[0]['Email'];
          this.selectedType = loggedInUsers[0]['Type'];
          // this.getUserCrs();
        } else if (loggedInUsers && loggedInUsers.length > 0 && loggedInUsers[0]['Email'] && loggedInUsers[0]['Type']) {
          this.currentUser.cpr = loggedInUsers[0]['Email'];
          // this.CPRNumber = loggedInUsers[0]['Email'];
          //this.selectedType = loggedInUsers[0]['Type'];
          //this.getUserCrs();
        }
      },
      error => {
        console.error(error);
      }
    );
  }
}